import React from "react";
import { ASSETS, APP_URL } from "@/data/landing";

export const SiteFooter = () => (
  <footer data-testid="site-footer" className="bg-afwn-navy text-white/70 pt-16 pb-10 border-t border-white/5">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <img src={ASSETS.logo} alt="AFWN" className="h-12 w-12 object-contain rounded-full bg-white/5" />
            <span className="font-heading text-xl text-white">Anxiety Fix<span className="block text-[9px] tracking-[0.25em] uppercase text-white/50 font-body">Wellness Network</span></span>
          </div>
          <p className="mt-4 text-sm max-w-xs">Compassionate, evidence-informed wellness support for Anxiety, PTSD, and Postpartum — anytime you need it.</p>
          <p className="mt-4 text-xs text-white/50 max-w-xs leading-relaxed" data-testid="footer-disclaimer">Anxiety Fix Wellness Network provides educational and wellness information and is not a medical or mental-health treatment provider. Our AI Assistants do not diagnose, treat, cure, or prevent any condition and are not a substitute for therapy or care from a qualified professional. Individual experiences vary. In crisis? Call or text 988 (US).</p>
        </div>
        <div>
          <h4 className="text-white font-medium mb-4 text-sm tracking-wider uppercase">Explore</h4>
          <ul className="space-y-2 text-sm">
            <li><a href="/#program" className="hover:text-afwn-amber transition-colors">Program</a></li>
            <li><a href="/#science" className="hover:text-afwn-amber transition-colors">The Science</a></li>
            <li><a href="/#pricing" className="hover:text-afwn-amber transition-colors">Pricing</a></li>
              <li><a href="/blog" data-testid="footer-blog-link" className="hover:text-afwn-amber transition-colors">Wellness Blog</a></li>
            <li><a href={APP_URL} className="hover:text-afwn-amber transition-colors">Launch the App</a></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-medium mb-4 text-sm tracking-wider uppercase">Legal</h4>
          <ul className="space-y-2 text-sm">
            <li><a href="/terms" data-testid="footer-terms-link" className="hover:text-afwn-amber transition-colors">Terms &amp; Conditions</a></li>
            <li><a href="/privacy" data-testid="footer-privacy-link" className="hover:text-afwn-amber transition-colors">Privacy Policy</a></li>
            <li><a href="/refunds" data-testid="footer-refunds-link" className="hover:text-afwn-amber transition-colors">Refund Policy</a></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-medium mb-4 text-sm tracking-wider uppercase">Contact</h4>
          <ul className="space-y-2 text-sm">
            <li>Email: <a href="mailto:support@anxiety-fix.com" className="hover:text-afwn-amber transition-colors">support@anxiety-fix.com</a></li>
            <li>Phone: <a href="tel:+18144572585" className="hover:text-afwn-amber transition-colors">1-814-457-2585</a></li>
          </ul>
        </div>
      </div>
      <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
        <p>© 2026 Anxiety Fix Wellness Network™ · K Shepard Enterprises, LLC</p>
        <p className="flex flex-wrap gap-x-4 gap-y-1 items-center">
          <a href="/terms" className="hover:text-afwn-amber transition-colors">Terms</a>
          <a href="/privacy" className="hover:text-afwn-amber transition-colors">Privacy</a>
          <a href="/refunds" className="hover:text-afwn-amber transition-colors">Refunds</a>
        </p>
      </div>
    </div>
  </footer>
);
